module.exports = __webpack_public_path__ + "img/whales.69913cfa.gif";